import { Component } from 'react'
import { connect } from 'react-redux'

import { trackEvent } from '@offerzen/pinata'

import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'
import {
  fetchJobExperiences as reduxFetchJobExperiences,
  createJobExperience as reduxCreateJobExperience,
  updateJobExperience as reduxUpdateJobExperience,
  deleteJobExperience as reduxDeleteJobExperience,
  toggleJobExperienceEdit as reduxToggleJobExperienceEdit,
  addBlankJobExperienceItem as reduxAddBlankJobExperienceItem,
  deleteBlankJobExperienceItem as reduxDeleteBlankJobExperienceItem,
  submit as reduxSubmit,
} from '../../redux/modules/jobExperiences'

import {
  jobExperiencesList,
  hasSubmittedJobExperiences,
  initialAreaFormValues,
  primaryRoles,
  availableRoles,
  loading,
} from '../../redux/selectors/areaRoles'
import { loadingCandidate } from '../../selectors/currentUser'

class AreaRoles extends Component {
  trackUser() {
    trackEvent('onboarding-area-roles-accessed')
  }

  componentDidMount() {
    this.props.candidate && this.trackUser()
    this.props.updateProgress(8)
    this.props.fetchJobExperiences()
  }

  render() {
    const { children, ...rest } = this.props
    return children(rest)
  }
}

const mapStateToProps = state => ({
  candidate: state.candidate,
  userId: state.candidate.user_id,
  yearsExperienceList: state.static_data.years_of_experience,
  rolesList: availableRoles(state),
  primaryRoles: primaryRoles(state),
  jobExperiencesList: jobExperiencesList(state),
  hasSubmittedJobExperiences: hasSubmittedJobExperiences(state),
  loadingCandidate: loadingCandidate(state),
  initialAreaFormValues: initialAreaFormValues(state),
  loading: loading(state),
})

const mapDispatchToProps = dispatch => ({
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
  fetchJobExperiences: candidateId => dispatch(reduxFetchJobExperiences(candidateId)),
  createJobExperience: (candidateId, data, resolve, reject) => {
    dispatch(reduxCreateJobExperience(candidateId, data, resolve, reject))
  },
  updateJobExperience: (data, resolve, reject) => {
    dispatch(reduxUpdateJobExperience(data, resolve, reject))
  },
  deleteJobExperience: jobExperienceId => {
    dispatch(reduxDeleteJobExperience(jobExperienceId))
  },
  toggleJobExperienceEdit: (jobExperienceId, value) => {
    dispatch(reduxToggleJobExperienceEdit(jobExperienceId, value))
  },
  addBlankJobExperienceItem: () => dispatch(reduxAddBlankJobExperienceItem(Date.now().toString())),
  deleteBlankJobExperienceItem: tempId => dispatch(reduxDeleteBlankJobExperienceItem(tempId)),
  submitJobExperience: (data, resolve, reject) => dispatch(reduxSubmit(data, resolve, reject)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  fetchJobExperiences: () => {
    dispatchProps.fetchJobExperiences(stateProps.candidate.id)
  },
  createJobExperience: (data, resolve, reject) => {
    dispatchProps.createJobExperience(stateProps.candidate.id, data, resolve, reject)
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AreaRoles)
